import { NextRequest, NextResponse } from 'next/server';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import Cookies from 'js-cookie';

import initializeApollo from 'apollo-client';

import { getRandomItemByWeights } from 'utils';

import EXPERIMENTS_QUERY from 'graphql/experiment/queries/experiments.graphql';

import {
  ExperimentGroupType,
  ExperimentStatusEnum,
  ExperimentType,
  GetExperimentsQuery,
} from 'graphql/types';

export interface IActiveExperiment {
  group: string;
  value: string;
}

export const activeExperiments: IActiveExperiment[] = [
  {
    group: 'recommended-content',
    value: 'show-recommended-content-badge',
  },
  {
    group: 'already-watched-content',
    value: 'show-already-watched-content-slider',
  },
];

export const getExperimentsSsr = async (
  client: ApolloClient<NormalizedCacheObject>
) => {
  try {
    return client.query<GetExperimentsQuery>({
      query: EXPERIMENTS_QUERY,
    });
  } catch (err) {
    console.log(err);
  }
};

export const initializeExperiments = async (
  req: NextRequest,
  res: NextResponse
): Promise<NextResponse> => {
  const apolloClient = initializeApollo();
  let cookies: { [key: string]: string } = {};

  req.cookies.getAll().forEach((item) => {
    cookies[item.name] = item.value;
  });

  //получаем список всех активных экспериментов с набором групп в каждом
  const experiments = (
    (await getExperimentsSsr(apolloClient))?.data
      .getCurrentExperiments as ExperimentType[]
  ).filter((experiment) => experiment.status === ExperimentStatusEnum.Active);

  const getGroupOfExperimentByWeights = (
    items: ExperimentGroupType[]
  ): ExperimentGroupType => {
    const weights: number[] = items.map((group) => group.groupWeight || 0);

    return getRandomItemByWeights(items, weights) as ExperimentGroupType;
  };

  const setExperimentsCookies = (experiments: ExperimentType[]) =>
    experiments.forEach((experiment: ExperimentType) => {
      if (experiment.groups?.length && !cookies[experiment.slug || '']) {
        const group: ExperimentGroupType = getGroupOfExperimentByWeights(
          experiment.groups as ExperimentGroupType[]
        );

        res.cookies.set({
          name: experiment.slug as string,
          value: group.slug as string,
          expires: new Date(experiment.finishedAt),
        });
      }
    });

  setExperimentsCookies(experiments);

  return res;
};

export const getExperimentValue = (slug: string) => {
  return Cookies.get(slug) || '';
};
